var _a;
export class ErrorBoundaryUtils {
    static extractExtensionErrorInfo(event) {
        let errorInfo = "Unknown Error Source";
        if (event) {
            // Try to extract reqeust url from the event if possible
            if (event instanceof ProgressEvent) {
                if (event.currentTarget instanceof XMLHttpRequest) {
                    errorInfo = `Event Type: ${event.type}, URL: ${event.currentTarget.responseURL}`;
                }
            }
            errorInfo = `Event Type: ${event.type}`;
        }
        return errorInfo;
    }
    static generateContextData(TenantStore, event) {
        const error = this.serializeEvent(event) || null;
        const tenant = {
            active: (TenantStore === null || TenantStore === void 0 ? void 0 : TenantStore.active)
                ? this.prepareObjectForSerialization(TenantStore.active)
                : null,
            activeAuthorities: (TenantStore === null || TenantStore === void 0 ? void 0 : TenantStore.activeAuthorities)
                ? this.prepareObjectForSerialization(TenantStore.activeAuthorities)
                : null,
            tenants: (TenantStore === null || TenantStore === void 0 ? void 0 : TenantStore.tenants)
                ? this.prepareObjectForSerialization(TenantStore.tenants)
                : null,
        };
        return { error, tenant };
    }
    static serializeEvent(event) {
        var _b, _c;
        const error = event.error || event.reason || event;
        const unhandledRejection = event.reason ||
            event.reason ||
            event;
        if (!error && !unhandledRejection) {
            // Return a default object if no error or unhandled rejection is found
            // Just in case some other error happnens that we did not account for
            return {
                message: "No error or unhandled rejection found",
                filename: "unknown",
                lineno: "unknown",
                colno: "unknown",
                target: event.target,
                currentTarget: event.currentTarget,
                composedPath: event.composedPath(),
                type: event.type,
                stack: "unknown",
                reason: "unknown",
                url: window.location.href,
            };
        }
        const serializedErrorEvent = {
            message: (error === null || error === void 0 ? void 0 : error.message) ||
                (unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.message) ||
                ((_b = unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.reason) === null || _b === void 0 ? void 0 : _b.message) ||
                error ||
                unhandledRejection ||
                "unknown",
            filename: (error === null || error === void 0 ? void 0 : error.filename) || (unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.filename) || "unknown",
            lineno: (error === null || error === void 0 ? void 0 : error.lineno) || (unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.lineno) || "unknown",
            colno: (error === null || error === void 0 ? void 0 : error.colno) || (unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.colno) || "unknown",
            target: event.target,
            currentTarget: event.currentTarget,
            composedPath: event.composedPath(),
            type: event.type,
            stack: (error === null || error === void 0 ? void 0 : error.stack) ||
                (unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.stack) ||
                ((_c = unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.reason) === null || _c === void 0 ? void 0 : _c.stack) ||
                "unknown",
            reason: (error === null || error === void 0 ? void 0 : error.reason) || (unhandledRejection === null || unhandledRejection === void 0 ? void 0 : unhandledRejection.reason) || "unknown",
            url: window.location.href,
        };
        return serializedErrorEvent;
    }
    static prepareObjectForSerialization(object) {
        const serializedObject = {};
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                serializedObject[key] = JSON.stringify(object[key]);
            }
        }
        return serializedObject;
    }
}
_a = ErrorBoundaryUtils;
ErrorBoundaryUtils.handleSharedError = (event, scope, TenantStore, TokenStore) => {
    var _b, _c, _d;
    if (!scope)
        return;
    let contextData = _a.generateContextData(TenantStore, event);
    contextData.error.message =
        _a.prepareObjectForSerialization(contextData.error.message) ||
            null;
    scope.setTags({ appType: "EXTENSION" });
    scope.setExtra("error", contextData.error);
    scope.setExtra("tenant", contextData.tenant);
    let tokenStore = TokenStore;
    tokenStore = Object.assign(Object.assign({}, tokenStore), { token: "hidden" });
    scope.setExtra("user", tokenStore);
    scope.setUser({
        id: (_b = tokenStore === null || tokenStore === void 0 ? void 0 : tokenStore.user) === null || _b === void 0 ? void 0 : _b.id,
        email: (_c = tokenStore === null || tokenStore === void 0 ? void 0 : tokenStore.user) === null || _c === void 0 ? void 0 : _c.username,
    });
    let sentryEvent = event;
    // If stack is unknown that most likely means the error is from an API or unknown origin
    if (contextData.error.stack === "unknown") {
        const additionalInfo = _a.extractExtensionErrorInfo(event);
        sentryEvent.message = additionalInfo || null;
    }
    function isErrorEvent(event) {
        return "message" in event;
    }
    // If event.message is not set, we will set it to the error message
    // Otherwise, we will have <unlabelled event> in the Sentry dashboard
    if (!sentryEvent.message) {
        sentryEvent.message =
            ((_d = contextData === null || contextData === void 0 ? void 0 : contextData.error) === null || _d === void 0 ? void 0 : _d.message) ||
                (isErrorEvent(event) ? event.message : "Unknown Error");
    }
    scope.captureEvent(sentryEvent);
};
ErrorBoundaryUtils.handleStandaloneError = (event, scope, TenantStore, TokenStore) => {
    var _b, _c, _d, _e, _f, _g;
    if (!scope)
        return;
    let contextData = _a.generateContextData(TenantStore, event);
    contextData.error.message =
        _a.prepareObjectForSerialization(contextData.error.message) ||
            null;
    scope.setTag("appType", "DASHBOARD");
    scope.setContext("error", contextData.error);
    scope.setContext("tenant", contextData.tenant);
    let tokenStore = TokenStore;
    tokenStore = Object.assign(Object.assign({}, tokenStore), { token: "hidden" });
    scope.setContext("user", tokenStore);
    scope.setUser({
        id: (_b = tokenStore === null || tokenStore === void 0 ? void 0 : tokenStore.user) === null || _b === void 0 ? void 0 : _b.id,
        email: (_c = tokenStore === null || tokenStore === void 0 ? void 0 : tokenStore.user) === null || _c === void 0 ? void 0 : _c.username,
    });
    // If stack is unknown that means the error is from api
    // And we need to set the event message so it can be displayed in the Sentry dashboard
    let sentryEvent = event;
    if (contextData.error.stack === "unknown") {
        // Set message to be /api/... so we can see the api endpoint in the Sentry dashboard
        sentryEvent.message =
            ((_g = (_f = (_e = (_d = contextData === null || contextData === void 0 ? void 0 : contextData.error) === null || _d === void 0 ? void 0 : _d.message) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.url) === null || _g === void 0 ? void 0 : _g.match(/\/api.*/)) ||
                "unknown";
    }
    scope.captureEvent(sentryEvent);
};
